import { FC } from "react"

import { Accordion, Grid, Typography } from "@mui/material"
import { useQueryItemsAdmin } from "api/reactQuery/queries/teacherAdmin"
import TextField from "components/form/common/field/textField"
import DetailsTransaction from "components/form/common/formPart/transactions/accordion/detailsTransaction"
import Summary from "components/form/common/formPart/transactions/accordion/summary"
import { useFormContext, useWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { PrimaryTile } from "styles/common/tile"
import { ITransactionItem } from "ts/interfaces/Transaction"

interface IProps {
  variant: "bonus" | "fine"
  title: string
  noElementsMessage: string
  tilesFieldName: "bonuses" | "fines"
  manualTitleFieldName: "bonusTitle" | "fineTitle"
  manualValueFieldName: "bonusValue" | "fineValue"
  manualTitleLabel: string
  defaultExpanded?: boolean
}

const PresetSection: FC<IProps> = ({
  variant,
  title,
  noElementsMessage,
  tilesFieldName,
  manualTitleFieldName,
  manualValueFieldName,
  manualTitleLabel,
  defaultExpanded,
}) => {
  const { t } = useTranslation()
  const { setValue } = useFormContext()

  const selectedTiles: ITransactionItem[] = useWatch({
    name: tilesFieldName,
    exact: true,
  })

  const { data, isLoading, isError } = useQueryItemsAdmin({
    variant,
    options: {},
  })

  const onTileClick = (item: ITransactionItem) => {
    setValue(tilesFieldName, [...selectedTiles, item])
  }

  return (
    <Accordion defaultExpanded={defaultExpanded}>
      <Summary title={title} selectedItemsAmount={selectedTiles.length} />
      <DetailsTransaction
        selectedItems={selectedTiles}
        noElementsMessage={noElementsMessage}
        data={data?.data}
        isLoading={isLoading}
        isError={isError}
        onTileClick={onTileClick}
        variant={variant}
        fieldName={tilesFieldName}
      >
        <Typography variant="body3" color="mockup.neutral40">
          {t("transaction.other")}
        </Typography>
        <PrimaryTile p="24px 16px 32px" sx={{ borderRadius: "16px" }}>
          <Grid container columnSpacing="16px" rowSpacing="40px">
            <Grid size={{ desktop: 8, tablet: 6, mobile: 12 }}>
              <TextField
                label={manualTitleLabel}
                size="small"
                name={manualTitleFieldName}
              />
            </Grid>
            <Grid size={{ desktop: 4, tablet: 6, mobile: 12 }}>
              <TextField
                label={t("transaction.value")}
                size="small"
                name={manualValueFieldName}
              />
            </Grid>
          </Grid>
        </PrimaryTile>
      </DetailsTransaction>
    </Accordion>
  )
}

export default PresetSection
